import React from "react";

import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { useShowcaseAudienceOverlap } from "./useShowcaseAudienceOverlap";

export function ShowcaseAudienceOverlapToggle({
  disabled,
}: {
  disabled?: boolean;
}) {
  const { available, status, run, turnOff } = useShowcaseAudienceOverlap();

  if (!available) return null;

  return (
    <div className="showcase-toolbar__row showcase-audience-overlap-toggle">
      <IDHFormattedMessage
        id="ws_audience_overlap"
        defaultMessage="Audience overlap"
      />

      {status === "pending" ? (
        <span className="showcase-audience-overlap-toggle__generating">
          <IDHFormattedMessage
            id="ws_generating"
            defaultMessage="Generating..."
          />
        </span>
      ) : (
        <CustomSwitch
          checked={status === "done"}
          disabled={disabled}
          onChange={() => (status === "done" ? turnOff() : run())}
        />
      )}
    </div>
  );
}
